import { render, staticRenderFns } from "./ListJeuxLivres.vue?vue&type=template&id=2a53746c"
import script from "./ListJeuxLivres.vue?vue&type=script&lang=js"
export * from "./ListJeuxLivres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports